import { render, staticRenderFns } from "./dolo-footer.vue?vue&type=template&id=0fb41148&scoped=true&"
import script from "./dolo-footer.vue?vue&type=script&lang=js&"
export * from "./dolo-footer.vue?vue&type=script&lang=js&"
import style0 from "./dolo-footer.vue?vue&type=style&index=0&id=0fb41148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb41148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VLayout})
